module.exports = __webpack_public_path__ + "static/img/honor30Pro_5G.360bc76a.png";